module.exports = __webpack_public_path__ + "img/Z60_01.f0175035.jpg";